var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.14,
    height: 19.14,
    viewBox: "0 0 19.14 19.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M38.418,23h-11.7A3.722,3.722,0,0,0,23,26.722v11.7a3.722,3.722,0,0,0,3.722,3.722h11.7a3.722,3.722,0,0,0,3.722-3.722v-11.7A3.722,3.722,0,0,0,38.418,23Zm1.063,2.206h.42V28.45H36.669V25.206Zm-9.639,5.4A3.36,3.36,0,1,1,29.2,32.57,3.36,3.36,0,0,1,29.842,30.608Zm10.437,7.81a1.834,1.834,0,0,1-1.818,1.85H26.722a1.834,1.834,0,0,1-1.855-1.813V30.608h2.855a5.232,5.232,0,1,0,9.7,0h2.86Z",
    transform: "translate(-23 -23)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5ac2f346d46715a259914561b04fb920.svg";
export { ForwardRef as ReactComponent };